// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2h2qz","choiceBoxes":"toolbarselects_choiceBoxes__sw8j-","simpleField":"toolbarselects_simpleField__3xJz0"};